import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type CancelIdentityProviderChangeRequestModalProps = {
    identityProviderName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
};

export const CancelIdentityProviderChangeRequestModal = (props: CancelIdentityProviderChangeRequestModalProps) => {
    const { identityProviderName, onModalClose, onSubmitHandler } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>CANCEL</b> the Change Request for the Identity Provider named <b>{identityProviderName}</b>.</p>
                <p>
                    Once the Change Request has been canceled, all undeployed changes that have been made will be rolled back and the Identity Provider will be reverted back to its last deployed state.
                    The changes that were made will be kept in the Identity Provider History view and can be recovered as long as no additional changes are made to this Identity Provider.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CANCEL}
            title={"Cancel Identity Provider Change Request"}
            body={bodyElement}
            buttonText={"Cancel Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};